
import { withData } from 'hocs/withData'
import { Select as CSelect, SelectProps } from './Select'

export const Select = withData(CSelect)
export type { SelectProps }

export default Select
